/**
 * BudgetTransactionService
 * Manual adjustments to the append-only spend ledger.
 * Route: api/budget-transactions
 */
export class BudgetTransactionService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? BudgetTransactionService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${BudgetTransactionService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** Post a signed manual adjustment (notes mandatory). */
    async postAdjustment(body) {
        const response = await this.http.post(this.buildUrl('adjustment'), body);
        if (!response.data)
            throw new Error(`Failed to post adjustment for budget ${body.budgetID}`);
        return response.data;
    }
    /**
     * The global ledger explorer (v3). Every filter is optional.
     *
     * Before v3 the ledger was readable ONLY one budget at a time with no filters at all, so
     * "what did we pay this supplier last quarter" could not be answered without database access.
     */
    async search(query = {}) {
        const response = await this.searchRaw(query);
        return response.data ?? null;
    }
    searchRaw(query = {}) {
        const params = new URLSearchParams();
        Object.entries(query).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '')
                params.set(key, String(value));
        });
        const qs = params.toString();
        // buildUrl() joins with a slash, which would yield ".../?a=1" — compose the query URL directly.
        const base = this.buildUrl();
        return this.http.get(qs ? `${base}?${qs}` : base);
    }
}
BudgetTransactionService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetTransactionService.BASE_PATH = 'api/budget-transactions';
//# sourceMappingURL=BudgetTransactionService.js.map